var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoTransfer = function SvgNoTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4501 89.2616C56.7801 89.2616 54.8701 74.2616 54.8701 74.2616C62.4301 88.4916 67.7101 89.2616 69.6601 86.5016C70.9101 84.7816 70.6601 82.8416 68.9501 80.6516C67.2401 78.4616 62.2701 72.3716 62.2701 72.3716C76.2701 84.0916 78.3301 76.7916 78.5801 74.7016C78.8301 72.6116 74.5101 70.8316 69.4501 68.8016C63.9201 66.6216 65.4501 64.1016 65.4501 64.1016C84.7501 42.0316 67.5101 27.1016 50.4501 27.1016C33.3901 27.1016 16.1601 42.0316 35.4501 64.1016C35.4501 64.1016 37.0201 66.6216 31.4501 68.8016C26.3401 70.8016 22.0201 72.5816 22.2701 74.6816C22.5201 76.7816 24.6601 84.0716 38.6301 72.3716C38.6301 72.3716 33.6301 78.5416 31.9501 80.7216C30.2701 82.9016 29.6601 85.2216 31.2401 86.5716C34.3801 89.2816 39.5 87.501 46.0301 74.3316C46 74.001 44.1201 89.2616 50.4501 89.2616Z",
    fill: "white",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4512 54.32C49.0612 54.32 48.0912 55.89 48.0912 58.13C48.0912 60.37 49.0912 61.94 50.4512 61.94C51.8112 61.94 52.8112 60.37 52.8112 58.13C52.8112 55.89 51.8412 54.32 50.4512 54.32ZM50.4512 50.5C53.8612 50.5 56.6212 53.91 56.6212 58.13C56.6212 62.35 53.8612 65.76 50.4512 65.76C47.0412 65.76 44.2812 62.34 44.2812 58.13C44.2812 53.92 47.0412 50.5 50.4512 50.5Z",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0701 44.9807C38.6425 44.9807 38.2245 45.1076 37.8691 45.3454C37.5136 45.5832 37.2368 45.9211 37.0736 46.3164C36.9104 46.7117 36.8682 47.1465 36.9524 47.5658C37.0366 47.985 37.2433 48.3699 37.5464 48.6716C37.8494 48.9733 38.2352 49.1782 38.6549 49.2604C39.0746 49.3426 39.5092 49.2984 39.9037 49.1334C40.2982 48.9684 40.6348 48.6899 40.871 48.3334C41.1071 47.9769 41.2321 47.5583 41.2301 47.1307C41.2328 46.8467 41.1787 46.5651 41.071 46.3024C40.9633 46.0397 40.8041 45.8012 40.6029 45.6008C40.4016 45.4005 40.1624 45.2425 39.8991 45.136C39.6359 45.0295 39.3541 44.9767 39.0701 44.9807V44.9807Z",
    fill: "white",
    stroke: "#BFC2C6",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8301 44.9805C61.4021 44.9785 60.9831 45.1038 60.6264 45.3403C60.2696 45.5769 59.9912 45.9142 59.8265 46.3093C59.6618 46.7044 59.6182 47.1395 59.7012 47.5594C59.7842 47.9793 59.9901 48.3651 60.2928 48.6678C60.5955 48.9705 60.9813 49.1764 61.4012 49.2594C61.8211 49.3425 62.2563 49.2989 62.6514 49.1341C63.0465 48.9694 63.3837 48.691 63.6203 48.3343C63.8569 47.9775 63.9821 47.5585 63.9801 47.1305C63.9815 46.8478 63.9268 46.5676 63.8192 46.3062C63.7116 46.0447 63.5533 45.8072 63.3534 45.6073C63.1534 45.4073 62.9159 45.249 62.6545 45.1415C62.393 45.0339 62.1128 44.9792 61.8301 44.9805V44.9805Z",
    fill: "white",
    stroke: "#BFC2C6",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5801 18.4514L22.7101 17.1914",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6406 13.6704L30.7706 12.4004",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6699 21.3489V18.8789",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6699 11.98V9.5",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 12.1289L22.8 13.5089",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5391 17.3398L30.5991 18.7198",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5 43.6116L7.13 42.3516",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0605 38.8205L15.1905 37.5605",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0898 46.5112V44.0312",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0898 37.1302V34.6602",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16992 37.2891L7.21992 38.6691",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9609 42.5L15.0209 43.88",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43.6116L87.13 42.3516",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0605 38.8205L95.1905 37.5605",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1016 46.5112V44.0312",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1016 37.1302V34.6602",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1699 37.2891L87.2299 38.6691",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9707 42.5L95.0207 43.88",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.22 62.5H63.06C61.37 62.5 60 63.87 60 65.56V87.8C60 89.49 61.37 90.86 63.06 90.86H81.22C82.91 90.86 84.28 89.49 84.28 87.8V65.56C84.28 63.87 82.91 62.5 81.22 62.5Z",
    fill: "white",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4414 79.0391H78.9214",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4414 73.4297H72.1814",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4414 84.6484H78.9214",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9989 63.67C76.9989 65.58 76.1789 67.13 71.5589 67.13C66.9389 67.13 66.1289 65.58 66.1289 63.67C66.1289 61.76 68.5589 59.5 71.5589 59.5C74.5589 59.5 76.9989 61.76 76.9989 63.67Z",
    fill: "white",
    stroke: "#BFC2C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-transfer.f301f30c.svg";
export { ForwardRef as ReactComponent };